import React, { createContext, useContext } from 'react';
import { en_US } from './en_US';
const LocaleContext = createContext(en_US);
export const useLocale = () => useContext(LocaleContext);
export const LocaleProvider = ({ locale = {}, children, }) => (React.createElement(LocaleContext.Provider, { value: {
        ...en_US,
        ...locale,
    } }, children));
//# sourceMappingURL=LocaleProvider.js.map